export interface LotActivityCandidate {
  material_transformation?: 'open' | 'thaw' | null;
  source_production_id?: string | null;
  produced_at?: string | null;
  transformed_at?: string | null;
  received_at?: string | null;
}

export interface LotActivity {
  label: 'Aperto' | 'Scongelato' | 'Prodotto' | 'Caricato';
  occurredAt: string;
}

export function materialLotOperationLabel(candidate: LotActivityCandidate): 'Aperto' | 'Scongelato' | null {
  if (candidate.material_transformation === 'thaw') return 'Scongelato';
  if (candidate.material_transformation === 'open') return 'Aperto';
  return null;
}

export function resolveLotActivity(candidate: LotActivityCandidate): LotActivity | null {
  const operation = materialLotOperationLabel(candidate);
  const occurredAt = operation
    ? candidate.transformed_at ?? candidate.received_at
    : candidate.source_production_id
      ? candidate.produced_at ?? candidate.received_at
      : candidate.received_at;
  if (!occurredAt || !Number.isFinite(Date.parse(occurredAt))) return null;
  if (operation) return { label: operation, occurredAt };
  return {
    label: candidate.source_production_id ? 'Prodotto' : 'Caricato',
    occurredAt,
  };
}

export function lotActivityText(candidate: LotActivityCandidate): string | null {
  const activity = resolveLotActivity(candidate);
  if (!activity) return null;
  const date = new Date(activity.occurredAt).toLocaleString('it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${activity.label} il ${date}`;
}
